import en from './locals/en/translation.json';

export default { en };
